import React, {useState, useEffect} from 'react';

const mapSearchResults = searchResults => (
    Array.isArray(searchResults)
    ? searchResults.map( (res, i) => {
        if(res && res.Document){
            res.Document.position = i + 1; // for analytics
        }

        return res;
    })
    : searchResults
)

export default (searchResults, currentPage, effect) => {
    const [paginatedSearchResults, setPaginatedSearchResults] = useState(searchResults);
    useEffect(() => {

        if(paginatedSearchResults !== searchResults){
            setPaginatedSearchResults(
                mapSearchResults(
                    currentPage === 1
                    ? searchResults
                    : (paginatedSearchResults || []).concat(searchResults)
                )
            );
            effect && effect(searchResults);
        }
    }, [searchResults]);

    return paginatedSearchResults;
}